import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../../common/rest-api/services/auth.service';
import { environment } from '../../../../environments/environment';
import { GtrakUser } from '../models/gtrak-user';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GtrakAuthService extends AuthService<GtrakUser> {

  protected get userType() { return GtrakUser; }
  protected loginEndpoint = environment.apiUrl + '/auth/login';
  protected testEndpoint = environment.apiUrl + '/auth/test';
  protected logoutEndpoint = environment.apiUrl + '/auth/logout';
  
  protected headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Accept', 'application/json');
  
  protected httpOptions = {
    headers: this.headers
  };
  
  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();

  get getUser() {
    return this.userSubject.value;
  }
  setUser(user: any) {
    
    this.userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  logout() {
    this.userSubject.next(null);
    localStorage.removeItem('user');
  }

  restoreUser() {
    const user = localStorage.getItem('user');
    if (user) {
      this.userSubject.next(JSON.parse(user));
    }
  }
}